import { LitElement, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import componentStyles from './fil-badge.styles.js';

/**
 * @tag fil-badge
 * @property {"error"|"information"|"notification"|"success"|"warning"|"100"|"200"|"300"|"400"|"500"|"600"} [color=information] Color of the badge
 * @property {string} [label] Label to show on badge
 * @property {"primary"|"secondary"} [palette=primary] Color palette of badge
 * @property {"standard"|"small"} [size=standard] Size of badge
 * @property {"outline"|"solid"} [variation=solid] Look of badge
 */
export class FilBadge extends LitElement {
  static properties = {
    color: { type: String },
    label: { type: String },
    palette: { type: String }, // 'primary' | 'secondary'
    size: { type: String }, // 'small' | 'standard'
    variation: { type: String }, // 'outline' | 'solid'
  };

  static styles = [componentStyles];

  constructor() {
    super();
    this.color = 'information';
    this.palette = 'primary';
    this.size = 'standard';
    this.variation = 'solid';
  }

  render() {
    const classes = {
      [`fil-badge--${this.size}`]: this.size !== 'standard',
      [`fil-badge--${this.palette ? this.palette : 'primary'}${
        this.variation !== 'solid' ? '-outline' : ''
      }-${this.color}`]: true,
    };

    return html`<span role="status" aria-label="${this.label}" class="fil-badge${classMap(classes)}"
      >${this.label}</span
    >`;
  }
}

export default FilBadge;
